export default __webpack_public_path__ + "static/media/guia-mobile-dark-3.14812b78.png";